import React from 'react';

const AssetsTab = () => {
  return (
    <div>
      <h2>Asset Management</h2>
      {/* Add asset management content */}
    </div>
  );
};

export default AssetsTab; 